/**
 * Lightweight toasts — replaces window.alert for errors and notices.
 * @param {string} message
 * @param {{ variant?: 'error' | 'info' | 'success'; duration?: number }} [opts]
 */
export function showToast(message, opts = {}) {
  const variant = opts.variant ?? "error";
  const duration =
    opts.duration ?? (variant === "error" ? 6500 : 4800);

  const root = ensureToastRoot();
  const el = document.createElement("div");
  el.className = `toast toast--${variant}`;
  el.setAttribute("role", variant === "error" ? "alert" : "status");
  el.textContent = message;
  root.appendChild(el);

  requestAnimationFrame(() => {
    el.classList.add("toast--show");
  });

  window.setTimeout(() => {
    el.classList.remove("toast--show");
    window.setTimeout(() => el.remove(), 320);
  }, duration);
}

function ensureToastRoot() {
  let root = document.getElementById("toast-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "toast-root";
    root.className = "toast-root";
    root.setAttribute("aria-live", "polite");
    root.setAttribute("aria-atomic", "true");
    document.body.appendChild(root);
  }
  return root;
}
